import React, {useEffect} from 'react';
import {Container, Row, Col, Button} from 'reactstrap';
import {lobbyTabsEnum} from '../cellcomAbroadVariables';
import CountryItemComponent from '../SearchAbroadPackage/CountryItemComponent';
import {gaSelectConnectedCountry} from './../gaReports';

const ConnectedCountryExistsPopupContent = (props) => {
  const {connectedCountry, lastSelected} = props;
  const title = `אם תכננתם לנסוע גם ל${connectedCountry.countryHebName},<br/> צריך להוסיף אותה. היא לא כלולה בחבילה של<span class="bold"> ${lastSelected.countryHebName}</span> `;
  const btnText = `${connectedCountry.countryHebName} לא בתוכנית הנסיעה שלי`;

  const saveCountry = () => {
    gaSelectConnectedCountry(props.activeLobbyTab, props.startedFromPackage, props.isSeparatedSale, props.isBusinessIndividual);
    props.setConnectedToSelectedCountry(null);
    props.saveSelectedCountry(connectedCountry);
  };
  return (
    <Container className='connected-country-popup'>
      <Row>
        <Col xs={12} className='text-center'>
          <span dangerouslySetInnerHTML={{__html: title}} />
        </Col>
      </Row>
      <Row>
        <Container>
          <Col>
            <CountryItemComponent
              country={connectedCountry}
              selected={false}
              action={() => saveCountry()}
              ConnectedCountryExistsPopupContent={true}
            />
          </Col>
        </Container>
      </Row>
      <Row>
        <Col>
          <Button color='link' className='pink pr-0 pl-0' onClick={() => props.closeModal()}>
            {btnText}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default ConnectedCountryExistsPopupContent;
